import WhatsNew from "~/components/WhatsNew/WhatsNew";
import * as React from 'react';
export default {
  WhatsNew,
  React
};